import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@radix-ui/themes';
import { useState } from 'react';

import DeleteComponent from '../../../shared/SettingsModal/DeleteComponent.jsx';
import { useNotification } from '../../../shared/Notification/useNotification';
import { deleteVaultFile } from '../data';
import { Modal } from '../../boardSetup/components/Modals/Modal.jsx';

export const DeleteFile = ({ item, setItem }) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('vault');
  const { showSuccess, showError } = useNotification();

  const onClose = () => {
    setOpen(false);
    setItem(null);
  };

  const onConfirm = async () => {
    try {
      await deleteVaultFile({ vaultFileId: item.id });
      await queryClient.invalidateQueries(['vaultFiles']);
      showSuccess({ content: t('fileDeleted') });
      onClose();
    } catch {
      showError({ content: t('fileDeleteFailed') });
    }
  };

  return (
    <>
      <Tooltip content={t('deleteFileTooltip')}>
        <IconButton
          variant="outline"
          size="2"
          color="gray"
          onClick={() => {
            setOpen(true);
          }}
        >
          <i className="fa-light fa-trash fa-lg" />
        </IconButton>
      </Tooltip>
      <Modal open={open} onClose={onClose}>
        <DeleteComponent
          phrases={[
            <>
              {t('vault:confirmDeletion.before')} <strong>{item.name}</strong>
              {t('vault:confirmDeletion.after')}
            </>,
          ]}
          onConfirm={onConfirm}
          onCancel={onClose}
        />
      </Modal>
    </>
  );
};
